var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalizacion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1185_60984)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.7948 4.20518C24.993 4.4033 25.0539 4.70044 24.9499 4.9606L16.7983 25.3394C16.4804 26.1344 15.3961 26.2356 14.9364 25.5133L10.4838 18.5162L3.4867 14.0636C2.76438 13.6039 2.86563 12.5196 3.66057 12.2017L24.0394 4.05012C24.2996 3.94606 24.5967 4.00705 24.7948 4.20518ZM11.8837 18.1069L15.7514 24.1847L22.3818 7.60876L11.8837 18.1069ZM21.3912 6.61818L4.8153 13.2486L10.8931 17.1163L21.3912 6.61818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7948 5.20518C26.993 5.4033 27.0539 5.70044 26.9499 5.9606L18.7983 26.3394C18.4804 27.1344 17.3961 27.2356 16.9364 26.5133L12.4838 19.5162L5.4867 15.0636C4.76438 14.6039 4.86563 13.5196 5.66057 13.2017L26.0394 5.05012C26.2996 4.94606 26.5967 5.00705 26.7948 5.20518ZM13.8837 19.1069L17.7514 25.1847L24.3818 8.60876L13.8837 19.1069ZM23.3912 7.61818L6.8153 14.2486L12.8931 18.1163L23.3912 7.61818Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1185_60984",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5296D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B58CA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizacion);
export default __webpack_public_path__ + "static/media/localizacion.25b336fd78f2c12e41812634c9714bdf.svg";
export { ForwardRef as ReactComponent };